export const CustomNotificationChanelEnum = {
  UNUSED_BONUSES: 'unused_bonuses',
  INSTALL_APP: 'install_app',
  VIP: 'vip',
  WELCOME_BONUSES: 'welcome_bonuses',
  RELOAD_BONUSES: 'reload_bonuses',
  BLOG_NOTIFICATIONS: 'blog_notifications',
} as const;


export const GameLimitsReasonEnum = {
  FORBIDDEN_WITH_BONUS: 'game_forbidden_with_bonus',
  BONUS_BET_LIMIT_EXCEEDED: 'bonus_bet_limit_exceeded',
  BET_LIMIT_EXCEEDED: 'bet_limit_exceeded',
  SESSION_LIMIT_EXCEEDED: 'session_limit_exceeded',
} as const;

export type GameLimitsReasonType = typeof GameLimitsReasonEnum[keyof typeof GameLimitsReasonEnum];
